/* eslint-disable no-mixed-operators */

/* eslint-disable no-bitwise */
// uuidv4 generator

/**
* 转换成16进制
* @return {string} e1ab33f1-0d12-4ba3-b9e7-d641aa14bdb0
* @memberof module:uuid
*/
function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
/**
 * 生成随机uint32整数
 * @returns 生成的随机数字
 */


function uint32() {
  return window.crypto.getRandomValues(new Uint32Array(1))[0];
}
/* eslint-disable import/prefer-default-export */


export { uuid, uint32 };